import { addAuthInterceptors } from '@dentalux/security';
import axios from 'axios';
const http = axios.create({
  baseURL: process.env.NEXT_PUBLIC_HADES_URL
});
addAuthInterceptors(http);
const bareHttp = axios.create({
  baseURL: process.env.NEXT_PUBLIC_HADES_URL
});
export const getBiometricChallenge = async ({
  trustedDeviceReferenceId
}) => {
  const {
    data
  } = await http.get('/biometric/challenge', {
    params: {
      deviceReferenceId: trustedDeviceReferenceId
    }
  });
  return data;
};
export const postRegisterPublicKey = async ({
  webAuthAttestation,
  trustedDeviceReferenceId
}) => {
  await http.post(`/biometric/register/${trustedDeviceReferenceId}`, webAuthAttestation);
};
export const getBiometricPreAuthenticate = async ({
  trustedDeviceReferenceId
}) => {
  const {
    data
  } = await bareHttp.get(`/authenticate/device/${trustedDeviceReferenceId}`);
  return data;
};
export const postBiometricAuthenticate = async ({
  trustedDeviceReferenceId,
  credential
}) => {
  const {
    data,
    headers
  } = await bareHttp.post(`/authenticate/device/${trustedDeviceReferenceId}`, credential);
  return {
    token: headers.authorization,
    refreshToken: headers['x-refresh-token'],
    user: data
  };
};
export const postElevateToken = async ({
  token,
  trustedDeviceReferenceId
}) => {
  const {
    data,
    headers
  } = await bareHttp.post(`/authenticate/elevate`, trustedDeviceReferenceId ? {
    deviceId: trustedDeviceReferenceId
  } : undefined, {
    headers: {
      Authorization: token
    }
  });
  return {
    token: headers.authorization,
    refreshToken: headers['x-refresh-token'],
    user: data
  };
};
export const deleteTrustedDevice = async referenceId => {
  const {
    data
  } = await http.delete(`/devices/${referenceId}`);
  return data;
};
export const getTrustedDevices = async () => {
  const {
    data
  } = await http.get('/devices', {
    params: {
      size: 1000
    }
  });
  return data;
};
export const patchPreferredLanguage = async (userReferenceId, languageCode) => {
  const {
    data
  } = await http.patch(`/users/patient/${userReferenceId}/language`, {
    languageCode
  });
  return data;
};
export const deletePatientAccount = async (userReferenceId, deletedReason) => {
  const {
    data
  } = await http.delete(`/users/patient/${userReferenceId}`, {
    params: {
      deletedReason
    }
  });
  return data;
};